import { CloseButton, Stack, Typography } from "@compass/core";

export const StudentQrPageHeader = () => {
    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="inherit">Student Mobile Pass</Typography>
            <CloseButton theme="Dark" />
        </Stack>
    );
};
